import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSeo } from '../hooks/useSeo';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import Contact from '../components/Contact';

export default function HomePage() {
  const { t } = useTranslation();
  useSeo({
    title: t('seo.home.title'),
    description: t('seo.home.description'),
    path: '/',
  });

  return (
    <>
      <Hero />
      <About />
      <Experience />
      <Skills />
      <Projects />
      <Contact />
    </>
  );
}
